


















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { ActionTypes } from "@/store/aciton-types";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component({
  props: {
    imageUrl: String
  }
})
export default class UploadAvatarComponent extends Vue {
  isUploading: boolean = false;

  // @Watch('imageUrl')
  // imageChange (newVal: any, oldVal: any) {
  //   this.imageUrl = this.$store.state.profile.avatar_url
  // }

  // checkImage () {
  //   this.imageUrl = this.$store.state.profile.avatar_url
  // }

  get backgroundImage() {
    return "url('" + this.$props.imageUrl + "')";
  }

  onImageChange(event: HTMLInputEvent) {
    const files = event.target.files || null;
    if (files === null) {
      return
    }

    if (!files.length) {
      return
    }

    this.isUploading = true
    this.$store.dispatch(ActionTypes.UPLOAD_AVATAR, { file: files[0] })
  }
}
